import useLoading from '../../control/loading/useLoading'
import useCallApi from '../../utilities/axios'
import * as umServiceURL from './umServiceURL'

// export type FormType = {
//     username: string
// }

const useCheckPersonnel = () => {
    const callApi = useCallApi()
    const loadingHook = useLoading()

    const postCheckPersonnel = async (personnelId: string) => {
        try {
            loadingHook.loadingOpen()
            const { data } = await callApi.axiosPost<any>({
                url: umServiceURL.postCheckPersonnel,
                // url: 'http://curecdev.research.chula.ac.th/curecapi-test/api/users/check/personnel',
                params: { personnelId },
            })

            return data
        } finally {
            loadingHook.loadingClose()
        }
    }
    return { postCheckPersonnel }
}

export default useCheckPersonnel
